import {
    object, string,
} from 'yup';

export const LOGIN_FIELD_NAMES = {
    password: 'password',
    email: 'email',
};
export const password = {
    id: 'login-password',
    name: LOGIN_FIELD_NAMES.password,
    type: 'password',
};
export const email = {
    id: 'login-email',
    name: LOGIN_FIELD_NAMES.email,
    type: 'email',
};

export const loginSchema = (t) => object().shape({
    password: string().required(t('error.password.empty')),
    email: string().required(t('error.email.empty'))
        .email(t('error.email.wrong')),

});
